import React from 'react';

const withForwardedRef = BaseComponent =>
  React.forwardRef((props, ref) => (
    <BaseComponent {...props} forwardedRef={ref} />
  ));

export default withForwardedRef;
